import { render, staticRenderFns } from "./ButtonFloatMenu.vue?vue&type=template&id=c2245ab4&scoped=true&lang=pug&"
import script from "./ButtonFloatMenu.vue?vue&type=script&lang=ts&"
export * from "./ButtonFloatMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonFloatMenu.vue?vue&type=style&index=0&id=c2245ab4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2245ab4",
  null
  
)

export default component.exports